export type TableState = 'Ready' | 'Dirty' | 'Blocked';

const TableStates: { [id: string]: TableState } = {
  // Ordered by meal progression
  ready: 'Ready',
  dirty: 'Dirty',
  blocked: 'Blocked',
};

export const TableStateMapping = {
  [TableStates.ready]: {
    text: textForState(TableStates.ready),
    value: TableStates.ready,
  },
  [TableStates.dirty]: {
    text: textForState(TableStates.dirty),
    value: TableStates.dirty,
  },
  [TableStates.blocked]: {
    text: textForState(TableStates.blocked),
    value: TableStates.blocked,
  },
};

export function textForState(state: TableState) {
  switch (state) {
    case TableStates.ready:
      return 'Ready';
    case TableStates.dirty:
      return 'Needs prep';
    case TableStates.blocked:
      return "Don't use";
    default:
      return '';
  }
}

export default TableStates;
